"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _opensans = _interopRequireDefault(require("./opensans"));
var _ubuntu = _interopRequireDefault(require("./ubuntu"));
var fonts = (0, _defineProperty2.default)((0, _defineProperty2.default)({
  opensans: _opensans.default,
  ubuntu: _ubuntu.default,
  sparx: _opensans.default,
  law: _opensans.default,
  invest: _opensans.default,
  'vendor-loan': _ubuntu.default,
  dinamik: _opensans.default,
  esv: _ubuntu.default,
  internetbanking: _ubuntu.default,
  forward: _opensans.default
}, "invest", _opensans.default), "crypto", _opensans.default);
var _default = exports.default = fonts;